import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import CleaningIndustry from "@/pages/industries/CleaningIndustry";
export const Route = createFileRoute("/industries/cleaning")({ head: ({match}) => pageHead(match.pathname), component: () => (<CleaningIndustry />) });
